import { useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useIncompleteWorkOrder } from '@api/enterprise/workorder/mutations';
import {
  LockedStatusChip as LockedStatusChipBase,
  UnlockConfirmationDialog
} from '@components/LockedStatusChip';

export const LockedStatusChip = () => {
  const { t } = useTranslation('workOrders');
  const { jobNumber } = useParams<{ jobNumber: string }>();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { mutate: incompleteWorkOrder, isPending } = useIncompleteWorkOrder(
    () => {
      setIsDialogOpen(false);
    }
  );

  const handleUnlockClick = () => {
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    if (!isPending) {
      setIsDialogOpen(false);
    }
  };

  const handleConfirm = useCallback(() => {
    if (jobNumber) {
      incompleteWorkOrder({ jobNumber });
    }
  }, [jobNumber, incompleteWorkOrder]);

  return (
    <>
      <LockedStatusChipBase
        onUnlock={handleUnlockClick}
        isPending={isPending}
        labels={{
          locked: t('unlock.lockedLabel', 'Locked'),
          unlockButton: t('unlock.button')
        }}
      />
      <UnlockConfirmationDialog
        open={isDialogOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isPending}
        title={t('unlock.dialogTitle')}
        message={t('unlock.dialogMessage')}
        cancelText={t('unlock.cancel')}
        confirmText={t('unlock.confirm')}
      />
    </>
  );
};
